const AUDIENCES = [
  {
    icon: "bi-person-badge",
    iconClass: "bg-[#E6F7F3] text-[#0B8F7A]",
    title: "Employees",
    text: "HR and workplace processing covered by clear, purpose-bound employee consent and notices.",
    items: [
      "Onboarding & payroll notices",
      "Biometric / CCTV / monitoring purposes",
      "Withdrawal & retention linked to HRIS",
    ],
  },
  {
    icon: "bi-building",
    iconClass: "bg-[#E8F0FE] text-[#2B6CB0]",
    title: "Vendors",
    text: "Processor and vendor relationships with consent, contractual notices and data-sharing purpose records.",
    items: [
      "Vendor onboarding consent packs",
      "Sub-processor disclosure tracking",
      "Linked to TPRM risk profiles",
    ],
  },
  {
    icon: "bi-handshake",
    iconClass: "bg-[#F0E8FF] text-[#6B46C1]",
    title: "Partners",
    text: "Joint ventures, channel partners and affiliates — shared purposes with clear accountability.",
    items: [
      "Co-branded and shared processing",
      "Cross-entity consent mapping",
      "Expiry and renewal reminders",
    ],
  },
];

export default function Audiences() {
  return (
    <section id="audiences" className="py-20 bg-white border-b border-line">
      <div className="container mx-auto max-w-[1140px] px-4">
        <p className="inline-block text-[0.78rem] font-semibold tracking-[0.12em] uppercase text-teal mb-[0.85rem]">
          Unified consent hub
        </p>
        <h2 className="font-bricolage text-[clamp(1.75rem,3vw,2.3rem)] mb-[0.7rem] text-ink">
          Manage consents at one place
        </h2>
        <p className="text-[1.05rem] leading-[1.65] text-slate max-w-[40rem]">
          Whether you are onboarding employees, contracting vendors or
          collaborating with partners — OneDPDP holds every consent purpose,
          status and proof in a single, auditable record.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-11">
          {AUDIENCES.map((a) => (
            <div
              key={a.title}
              className="p-[1.85rem_1.6rem] rounded-xl border border-line bg-surface transition-all hover:-translate-y-1 hover:border-teal/40 hover:shadow-[0_16px_36px_rgba(7,17,31,0.07)]"
            >
              <div className={`w-[52px] h-[52px] rounded-xl flex items-center justify-center text-[1.4rem] mb-[1.15rem] ${a.iconClass}`}>
                <i className={`bi ${a.icon}`} />
              </div>
              <h3 className="text-[1.2rem] font-bricolage font-semibold mb-2">{a.title}</h3>
              <p className="m-0 text-slate text-[0.95rem] leading-[1.55]">{a.text}</p>
              <ul className="list-none p-0 mt-[1.15rem] mb-0">
                {a.items.map((item) => (
                  <li key={item} className="flex gap-[0.55rem] text-[0.88rem] text-slate-2 py-[0.35rem]">
                    <i className="bi bi-check2 text-teal mt-[2px]" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
